// Idle-logout: sign the user out after 30 min of no activity
import { logout } from "@/lib/auth";

const IDLE_MS = 30 * 60 * 1000;
let timer = null;

const reset = () => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (localStorage.getItem("bb_token")) {
      try { logout(); } catch { window.location.href = "/login"; }
    }
  }, IDLE_MS);
};

export const initIdleLogout = () => {
  if (typeof window === "undefined") return;
  ["mousemove", "mousedown", "keydown", "touchstart", "scroll"].forEach(ev =>
    window.addEventListener(ev, reset, { passive: true })
  );
  reset();
};
